export function nameof(key1, key2) {
  return key2 ?? key1;
}